import { RotateCcw } from 'lucide-react';

/**
 * Sprint 9.2 — Botón para reactivar una mesa fuera de servicio.
 *
 * Sprint 29.1 — El menú kebab (`MesaActionsMenu`) se eliminó: todas las
 * acciones de la mesa ahora son botones visibles en `MesasGrid` (mejor
 * descubribilidad). Este archivo conserva sólo el botón de reactivar, que se
 * muestra en lugar de "Nuevo pedido" cuando la mesa está fuera de servicio.
 */
export function ReactivarMesaButton({ onClick }: { onClick: () => void }) {
  return (
    <button onClick={onClick} className="btn-secondary w-full" type="button">
      <RotateCcw className="h-4 w-4" />
      Reactivar mesa
    </button>
  );
}
